import React from 'react';
import PropTypes from 'prop-types';

import InputFieldErrorMessage from '../../../../common/components/InputFieldErrorMessage';

import { requiredField } from '../../forms/EventListingsForm';
import { statesAndTerritories, countries } from '../../../../common/helpers/geographicConstants';
import styles from './EventListingsEventLocationInputs.module.scss';

const EventListingsEventLocationInputs = ({
  fields,
  setField,
  validateField,
  resetField,
  setValidators,
}) => {
  const handleCompanyCountryChange = (e) => {
    // Clear out company state field if country selected is not US,
    // Remove any lingering required field errors
    if (e.target.value !== 'United States') {
      // TODO: Keep event and useFormControls states in sync
      resetField('stateTerritory');
      setValidators('stateTerritory', []);
    } else {
      setValidators('stateTerritory', [requiredField]);
    }
    setField({
      target: {
        name: 'country',
        value: e.target.value,
      },
    });
  };

  return (
    <>
      <div className={styles['field-label']}>
        Event location
        {(fields.locationType.value === 'IN_PERSON')
          && <span className={styles.required}>*</span>}
      </div>
      <div className={styles['address-line-one-wrapper']}>
        <input
          type="text"
          name="addressLine1"
          id="addressLine1"
          placeholder={fields.addressLine1.label}
          onChange={setField}
          onBlur={validateField}
          value={fields.addressLine1.value}
        />
        <InputFieldErrorMessage field={fields.addressLine1} />
      </div>
      <input
        type="text"
        name="addressLine2"
        id="addressLine2"
        placeholder={fields.addressLine2.label}
        onChange={setField}
        onBlur={validateField}
        value={fields.addressLine2.value}
      />
      <div className={styles['geographic-container']}>
        <div className={styles['geo-element']}>
          <input
            type="text"
            name="city"
            maxLength="200"
            id="city"
            placeholder={fields.city.label}
            style={{ marginBottom: '0.5rem' }}
            onChange={setField}
            onBlur={validateField}
            value={fields.city.value}
          />
          <InputFieldErrorMessage field={fields.city} />
        </div>
        <div className={`${styles['geo-element']} ${styles['geo-element--center']}`}>
          <select
            name="country"
            id="country"
            aria-label="Enter your company country"
            onChange={handleCompanyCountryChange}
            onBlur={validateField}
            value={fields.country.value}
            style={{ marginBottom: '0.5rem' }}
          >
            <option value="" aria-label="No country selected">{fields.country.label}</option>
            {countries.map((country) => {
              return (
                <option key={country.value} value={country.value}>
                  {country.label}
                </option>
              );
            })}
          </select>
          <InputFieldErrorMessage field={fields.country} />
        </div>
        <div
          className={styles['geo-element']}
          style={{ opacity: fields.country.value === 'United States' ? 1 : 0.6 }}
        >
          <select
            disabled={fields.country.value !== 'United States'}
            name="stateTerritory"
            id="stateTerritory"
            aria-label="Enter your company's state or territory"
            onChange={setField}
            onBlur={validateField}
            value={fields.stateTerritory.value}
            style={{ marginBottom: '0.5rem' }}
          >
            <option value="" aria-label="None selected">{fields.stateTerritory.label}</option>
            {statesAndTerritories.map((state) => {
              return (
                <option key={state.value} value={state.value}>
                  {state.label}
                </option>
              );
            })}
          </select>
          <InputFieldErrorMessage field={fields.stateTerritory} />
        </div>
      </div>
    </>

  );
};

EventListingsEventLocationInputs.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  fields: PropTypes.object.isRequired,
  setField: PropTypes.func.isRequired,
  validateField: PropTypes.func.isRequired,
  resetField: PropTypes.func.isRequired,
  setValidators: PropTypes.func.isRequired,
};

export default EventListingsEventLocationInputs;
